var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          _vm.loginAction($event)
        }
      }
    },
    [
      _c("div", { staticClass: "fb-login", style: { display: _vm.fbStyle } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 text-center" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-facebook",
                  attrs: { href: "/app/auth/facebook", role: "button" }
                },
                [
                  _c("span", { staticClass: "fab fa-facebook-f" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$i18n.auth.login_with_facebook) +
                      "\n                    "
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row or-login" }, [
          _c("div", { staticClass: "col-md-12 text-center" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$i18n.general.or) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 text-center" }, [
            _c("label", [
              _c(
                "a",
                {
                  staticClass: "text-light show-login-form",
                  on: { click: _vm.showLoginForm }
                },
                [_vm._v(_vm._s(_vm.$i18n.auth.login_with_email_password))]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-form", style: { display: _vm.emailStyle } },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "email" } }, [
              _vm._v(_vm._s(_vm.$i18n.auth.email_address))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.email,
                  expression: "user.email"
                }
              ],
              staticClass: "form-control",
              attrs: { name: "email", type: "email", id: "email" },
              domProps: { value: _vm.user.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.user.email = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "password" } }, [
              _vm._v(_vm._s(_vm.$i18n.auth.password))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.password,
                  expression: "user.password"
                }
              ],
              staticClass: "form-control",
              attrs: {
                name: "password",
                type: "password",
                value: "",
                id: "password"
              },
              domProps: { value: _vm.user.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.user.password = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 text-center" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  staticClass: "btn btn-login",
                  attrs: { type: "submit" },
                  domProps: { value: _vm.$i18n.auth.log_in }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.remember,
                        expression: "user.remember"
                      }
                    ],
                    attrs: { name: "remember", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.user.remember)
                        ? _vm._i(_vm.user.remember, null) > -1
                        : _vm.user.remember
                    },
                    on: {
                      __c: function($event) {
                        var $$a = _vm.user.remember,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$c) {
                            $$i < 0 && (_vm.user.remember = $$a.concat($$v))
                          } else {
                            $$i > -1 &&
                              (_vm.user.remember = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.user.remember = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$i18n.auth.remember_me) +
                      "\n                    "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 text-right" }, [
              _c("div", { staticClass: "forgot-text" }, [
                _c(
                  "label",
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "text-light",
                        attrs: { to: { name: "recover-password" } }
                      },
                      [_vm._v(_vm._s(_vm.$i18n.auth.forgot_password))]
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row spacer-30" }, [
            _c("div", { staticClass: "col-md-12 text-center" }, [
              _c("label", [
                _c(
                  "a",
                  {
                    staticClass: "show-fb-form",
                    on: { click: _vm.showFacebookForm }
                  },
                  [
                    _c("i", {
                      staticClass: "fab fa-facebook-square",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" " + _vm._s(_vm.$i18n.auth.login_with_facebook))
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05e263b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e263b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/login/login-form.vue
// module id = 1268
// module chunks = 4